<script lang="ts" setup generic="T extends string">
  import { useI18n } from 'vue-i18n'

  type Props = {
    items: Record<T, string>
  }

  const props = defineProps<Props>()
  const emit = defineEmits<{
    (e: 'reset'): void
  }>()
  const model = defineModel<T>({ required: true })
  const { t } = useI18n()

  function handleItemClick(item: T) {
    model.value = item
    if (model.value === item) {
      emit('reset')
    }
  }

</script>

<template>
  <div class="c-button-selector">
    <button
      v-for="item in Object.keys(props.items) as T[]"
      :key="item + '-button'"
      :class="{ selected: model === item, blank: !props.items[item] }"
      @click="handleItemClick(item)"
    >
      <span> {{ t(props.items[item]) }}</span>
    </button>
  </div>
</template>

<style scoped>

.c-button-selector {
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: row;
  margin: 1em auto;
  overflow-x: auto;

  button {
    display: flex;
    flex: 1 1 auto;
    padding: 0.625rem;
    border: none;
    border-radius: 0.25rem;
    background-color: var(--color-secondary-light);
    color: var(--color-secondary);
    font-family: Open-Sans, sans-serif;
    font-size: 1.125em;
    font-weight: 600;

    &:not(:first-child) {
      margin-left: 0.5rem;
    }

    span {
      display: inline-block;
      width: 100%;
      line-height: 1.5rem;
      opacity: 0.6;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &.selected {
      background-color: var(--color-primary);

      span {
        opacity: 0.8;
      }
    }

    &.blank {
      opacity: 0;
      visibility: hidden;
    }
  }

  &.wrap {
    position: relative;
    flex-wrap: wrap;
    overflow-x: hidden;

    button {
      width: auto;

      span {
        margin: 0 auto;
        font-size: 1em;
      }
    }
  }

  @media screen and (width >= 1024px) {
    margin: 0;
  }
}
</style>
